module.exports = __webpack_public_path__ + "static/media/arrow-back.df1a9269.svg";